/**
 * Dispatched to open the global QuickSearch overlay from outside of the
 * QuickSearchBar component tree (e.g. a sidebar trigger). Mirrors the pattern
 * used by `OPEN_NOTIFICATIONS_EVENT` for the notifications dropdown.
 */
// eslint-disable-next-line import/prefer-default-export -- single named export is intentional to match OPEN_NOTIFICATIONS_EVENT
export const OPEN_QUICK_SEARCH_EVENT = 'synop:open-quick-search'
